import { useCallback, useState } from 'react';

const NET_TERMS_PROMOTION_DISMISSED_KEY = 'net_terms_promotion_dismissed';

interface UseLocalStorageDismissReturn {
  isNetTermsPromotionDismissed: boolean;
  dismissNetTermsPromotion: () => void;
}

const getInitialValue = (): boolean =>
  window.localStorage.getItem(NET_TERMS_PROMOTION_DISMISSED_KEY) === 'true';

export const useLocalStorageDismiss = (): UseLocalStorageDismissReturn => {
  const [isNetTermsPromotionDismissed, setIsNetTermsPromotionDismissed] =
    useState(() => getInitialValue());

  const dismissNetTermsPromotion = useCallback(() => {
    window.localStorage.setItem(NET_TERMS_PROMOTION_DISMISSED_KEY, 'true');
    setIsNetTermsPromotionDismissed(true);
  }, []);

  return {
    isNetTermsPromotionDismissed,
    dismissNetTermsPromotion,
  };
};
